export default __webpack_public_path__ + "static/media/s.764d18d1.svg";